var $9wzIk$react = require("react");
var $9wzIk$reactjsxruntime = require("react/jsx-runtime");
var $9wzIk$styledcomponents = require("styled-components");
var $9wzIk$muimaterialFormControl = require("@mui/material/FormControl");
var $9wzIk$muimaterialFormHelperText = require("@mui/material/FormHelperText");
var $9wzIk$muimaterialuseMediaQuery = require("@mui/material/useMediaQuery");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormControlWrapper", {
    enumerable: true,
    get: function get() {
        return $aa033f5f93edad43$exports.FormControlWrapper;
    }
});
Object.defineProperty(module.exports, "showCookiesPopup", {
    enumerable: true,
    get: function get() {
        return $f1e5b4aaf78d765a$exports.showCookiesPopup;
    }
});
Object.defineProperty(module.exports, "useWidth", {
    enumerable: true,
    get: function get() {
        return $f1ed9d87b4d065fe$exports.useWidth;
    }
});
var $f1e5b4aaf78d765a$exports = {};
"use strict";
Object.defineProperty($f1e5b4aaf78d765a$exports, "__esModule", {
    value: true
});
$f1e5b4aaf78d765a$exports.showCookiesPopup = void 0;
var $f081bdb29a02e5d9$exports = {};
"use strict";
Object.defineProperty($f081bdb29a02e5d9$exports, "__esModule", {
    value: true
});
$f081bdb29a02e5d9$exports.GDPR_COOKIE_ACCEPTANCE_COUNTRY_TIME_ZONE_ID_MAP = void 0;
var $f081bdb29a02e5d9$var$GDPR_COOKIE_ACCEPTANCE_COUNTRY_TIME_ZONE_ID_MAP = $f081bdb29a02e5d9$exports.GDPR_COOKIE_ACCEPTANCE_COUNTRY_TIME_ZONE_ID_MAP = {
    AT: [
        "Europe/Vienna"
    ],
    EE: [
        "Europe/Tallinn"
    ],
    IT: [
        "Europe/Rome"
    ],
    PT: [
        "Atlantic/Azores",
        "Atlantic/Madeira",
        "Europe/Lisbon"
    ],
    BE: [
        "Europe/Brussels"
    ],
    FI: [
        "Europe/Helsinki"
    ],
    LV: [
        "Europe/Riga"
    ],
    RO: [
        "Europe/Bucharest"
    ],
    BG: [
        "Europe/Sofia"
    ],
    FR: [
        "Europe/Paris"
    ],
    LT: [
        "Europe/Vilnius"
    ],
    SK: [
        "Europe/Bratislava",
        "Europe/Prague"
    ],
    HR: [
        "Europe/Belgrade",
        "Europe/Zagreb"
    ],
    DE: [
        "Europe/Berlin",
        "Europe/Busingen",
        "Europe/Zurich"
    ],
    LU: [
        "Europe/Brussels",
        "Europe/Luxembourg"
    ],
    SI: [
        "Europe/Belgrade",
        "Europe/Ljubljana"
    ],
    CY: [
        "Asia/Famagusta",
        "Asia/Nicosia"
    ],
    GR: [
        "Europe/Athens"
    ],
    MT: [
        "Europe/Malta"
    ],
    ES: [
        "Africa/Ceuta",
        "Atlantic/Canary",
        "Europe/Madrid"
    ],
    CZ: [
        "Europe/Prague"
    ],
    HU: [
        "Europe/Budapest"
    ],
    NL: [
        "Europe/Amsterdam",
        "Europe/Brussels"
    ],
    SE: [
        "Europe/Berlin",
        "Europe/Stockholm"
    ],
    DK: [
        "Europe/Berlin",
        "Europe/Copenhagen"
    ],
    IE: [
        "Europe/Dublin"
    ],
    PL: [
        "Europe/Warsaw"
    ],
    GB: [
        "Europe/London"
    ]
};


var $f1e5b4aaf78d765a$var$showCookiesPopup = $f1e5b4aaf78d765a$exports.showCookiesPopup = function showCookiesPopup() {
    try {
        var _Intl$DateTimeFormat$ = Intl.DateTimeFormat().resolvedOptions(), timeZone = _Intl$DateTimeFormat$.timeZone;
        if (!timeZone) return true;
        var gdprAcceptedTimezones = Object.values($f081bdb29a02e5d9$exports.GDPR_COOKIE_ACCEPTANCE_COUNTRY_TIME_ZONE_ID_MAP).flat();
        return gdprAcceptedTimezones.includes(timeZone);
    } catch (err) {
        return true;
    }
};


var $aa033f5f93edad43$exports = {};
"use strict";
Object.defineProperty($aa033f5f93edad43$exports, "__esModule", {
    value: true
});
Object.defineProperty($aa033f5f93edad43$exports, "FormControlWrapper", {
    enumerable: true,
    get: function get() {
        return $779b5eb575661221$exports.FormControlWrapper;
    }
});
var $779b5eb575661221$exports = {};
"use strict";
Object.defineProperty($779b5eb575661221$exports, "__esModule", {
    value: true
});
Object.defineProperty($779b5eb575661221$exports, "FormControlWrapper", {
    enumerable: true,
    get: function get() {
        return $66aaf65e9b66a9df$exports.FormControlWrapper;
    }
});
var $66aaf65e9b66a9df$exports = {};
"use strict";
Object.defineProperty($66aaf65e9b66a9df$exports, "__esModule", {
    value: true
});
$66aaf65e9b66a9df$exports.FormControlWrapper = void 0;

var $66aaf65e9b66a9df$var$_react = $66aaf65e9b66a9df$var$_interopRequireDefault($9wzIk$react);
var $e371e39083862412$exports = {};
"use strict";
Object.defineProperty($e371e39083862412$exports, "__esModule", {
    value: true
});
$e371e39083862412$exports.FormHelperText = $e371e39083862412$exports.FormControl = void 0;

var $e371e39083862412$var$_styledComponents = $e371e39083862412$var$_interopRequireDefault($9wzIk$styledcomponents);

var $e371e39083862412$var$_FormControl = $e371e39083862412$var$_interopRequireDefault($9wzIk$muimaterialFormControl);

var $e371e39083862412$var$_FormHelperText = $e371e39083862412$var$_interopRequireDefault($9wzIk$muimaterialFormHelperText);
var $e371e39083862412$var$_templateObject, $e371e39083862412$var$_templateObject2;
function $e371e39083862412$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $e371e39083862412$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $e371e39083862412$var$FormControl = $e371e39083862412$exports.FormControl = (0, $e371e39083862412$var$_styledComponents["default"])($e371e39083862412$var$_FormControl["default"]).attrs(function() {
    return {
        classes: {
            root: "root"
        }
    };
})($e371e39083862412$var$_templateObject || ($e371e39083862412$var$_templateObject = $e371e39083862412$var$_taggedTemplateLiteral([
    "\n  &.root {\n    width: 100%;\n\n    && * {\n      cursor: ",
    ";\n    }\n  }\n"
])), function(props) {
    return props.disabled && "no-drop";
});
var $e371e39083862412$var$FormHelperText = $e371e39083862412$exports.FormHelperText = (0, $e371e39083862412$var$_styledComponents["default"])($e371e39083862412$var$_FormHelperText["default"]).attrs(function() {
    return {
        classes: {
            root: "root"
        }
    };
})($e371e39083862412$var$_templateObject2 || ($e371e39083862412$var$_templateObject2 = $e371e39083862412$var$_taggedTemplateLiteral([
    "\n  &.root {\n    ",
    ";\n    color: ",
    ";\n    padding: 0px;\n    margin: 0px;\n    letter-spacing: 0px;\n\n    &.Mui-error {\n      ",
    ";\n      color: ",
    ";\n      background: transparent;\n    }\n  }\n"
])), function(props) {
    return props.theme.typo.bodyXS;
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.color.e400;
});



function $66aaf65e9b66a9df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $66aaf65e9b66a9df$var$FormControlWrapper = $66aaf65e9b66a9df$exports.FormControlWrapper = function FormControlWrapper(props) {
    var className = props.className, error = props.error, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, children = props.children, helperText = props.helperText, errorText = props.errorText;
    return /*#__PURE__*/ (0, $9wzIk$reactjsxruntime.jsxs)($e371e39083862412$exports.FormControl, {
        className: className,
        error: error,
        disabled: disabled,
        children: [
            children,
            !error && helperText && /*#__PURE__*/ (0, $9wzIk$reactjsxruntime.jsx)($e371e39083862412$exports.FormHelperText, {
                error: false,
                children: helperText
            }),
            error && errorText && /*#__PURE__*/ (0, $9wzIk$reactjsxruntime.jsx)($e371e39083862412$exports.FormHelperText, {
                children: errorText
            })
        ]
    });
};






var $f1ed9d87b4d065fe$exports = {};
"use strict";
Object.defineProperty($f1ed9d87b4d065fe$exports, "__esModule", {
    value: true
});
Object.defineProperty($f1ed9d87b4d065fe$exports, "useWidth", {
    enumerable: true,
    get: function get() {
        return $b287f3a707d8a4a3$exports.useWidth;
    }
});
var $b287f3a707d8a4a3$exports = {};
"use strict";
Object.defineProperty($b287f3a707d8a4a3$exports, "__esModule", {
    value: true
});
$b287f3a707d8a4a3$exports.useWidth = void 0;
var $bb6a8a3022cc23ea$exports = {};
"use strict";
Object.defineProperty($bb6a8a3022cc23ea$exports, "__esModule", {
    value: true
});
$bb6a8a3022cc23ea$exports.viewports = $bb6a8a3022cc23ea$exports.typoSelector = $bb6a8a3022cc23ea$exports.typo = $bb6a8a3022cc23ea$exports.query = $bb6a8a3022cc23ea$exports.layer = $bb6a8a3022cc23ea$exports.gradient = $bb6a8a3022cc23ea$exports.fontWeight = $bb6a8a3022cc23ea$exports.colorSelector = $bb6a8a3022cc23ea$exports.color = $bb6a8a3022cc23ea$exports.breakpoint = $bb6a8a3022cc23ea$exports.boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadow = $bb6a8a3022cc23ea$exports.border = $bb6a8a3022cc23ea$exports.Theme = void 0;

var $bebaee556f9a4756$exports = {};
"use strict";
Object.defineProperty($bebaee556f9a4756$exports, "__esModule", {
    value: true
});
$bebaee556f9a4756$exports.FONTS = void 0;
var $bebaee556f9a4756$var$FONTS = $bebaee556f9a4756$exports.FONTS = {
    displayXXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "62px",
        lineHeight: "150%"
    },
    displayXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "46px",
        lineHeight: "150%"
    },
    displayL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "34px",
        lineHeight: "150%"
    },
    displayM: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "24px",
        lineHeight: "150%"
    },
    displayS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    displayXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    displayXXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyL: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    bodyM: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    bodyS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyXS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "10px",
        lineHeight: "180%"
    }
};


var $bb6a8a3022cc23ea$var$_templateObject, $bb6a8a3022cc23ea$var$_templateObject2, $bb6a8a3022cc23ea$var$_templateObject3, $bb6a8a3022cc23ea$var$_templateObject4, $bb6a8a3022cc23ea$var$_templateObject5, $bb6a8a3022cc23ea$var$_templateObject6, $bb6a8a3022cc23ea$var$_templateObject7, $bb6a8a3022cc23ea$var$_templateObject8, $bb6a8a3022cc23ea$var$_templateObject9, $bb6a8a3022cc23ea$var$_templateObject10, $bb6a8a3022cc23ea$var$_templateObject11, $bb6a8a3022cc23ea$var$_templateObject12, $bb6a8a3022cc23ea$var$_templateObject13, $bb6a8a3022cc23ea$var$_templateObject14, $bb6a8a3022cc23ea$var$_templateObject15;
function $bb6a8a3022cc23ea$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $bb6a8a3022cc23ea$var$color = $bb6a8a3022cc23ea$exports.color = Object.freeze({
    p100: "#EEF7FF",
    p200: "#9AC7EF",
    p300: "#5AB1FF",
    p400: "#1D71F3",
    p500: "#1A4EC0",
    p600: "#112F86",
    a100: "#FFF6EC",
    a200: "#FFD3A5",
    a300: "#FF8932",
    a400: "#FF670A",
    a500: "#FF4D00",
    a600: "#A12A0B",
    b100: "#F0FDF1",
    b200: "#BAF8C3",
    b300: "#84F195",
    b400: "#47E160",
    b500: "#14B22E",
    b600: "#128325",
    c100: "#FDF1F2",
    c200: "#F7CAD4",
    c300: "#EE96A9",
    c400: "#DD5C75",
    c500: "#BB3853",
    c600: "#881D3F",
    d100: "#F6F4FE",
    d200: "#DFD9FB",
    d300: "#AB92F3",
    d400: "#7638DF",
    d500: "#491896",
    d600: "#30165F",
    g100: "#F6F6F8",
    g200: "#ECEEF2",
    g300: "#AEB8CB",
    g400: "#627495",
    g500: "#404B64",
    g600: "#262E41",
    e100: "#FFF1F1",
    e200: "#FFC7C5",
    e300: "#FF6A65",
    e400: "#ED2C25",
    e500: "#C7140E",
    e600: "#6D0400",
    white: "#FFFFFF",
    black: "#000000",
    facebook: "#4464a0",
    twitter: "#1da1f2",
    linkedin: "#0077b5"
});
var $bb6a8a3022cc23ea$var$colorSelector = $bb6a8a3022cc23ea$exports.colorSelector = function colorSelector(colorKey) {
    return function(props) {
        return props.theme.color[colorKey.toLowerCase()];
    };
};
var $bb6a8a3022cc23ea$var$typo = $bb6a8a3022cc23ea$exports.typo = Object.freeze(Object.keys($bebaee556f9a4756$exports.FONTS).reduce(function(acc, key) {
    acc[key] = (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject || ($bb6a8a3022cc23ea$var$_templateObject = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n      font-family: ",
        ";\n      line-height: ",
        ";\n    "
    ])), $bebaee556f9a4756$exports.FONTS[key].fontSize, $bebaee556f9a4756$exports.FONTS[key].fontFamily, $bebaee556f9a4756$exports.FONTS[key].lineHeight);
    return acc;
}, {}));
var $bb6a8a3022cc23ea$var$typoSelector = $bb6a8a3022cc23ea$exports.typoSelector = function typoSelector(typoKey) {
    return function(props) {
        return props.theme.typo[typoKey];
    };
};
var $bb6a8a3022cc23ea$var$fontWeight = $bb6a8a3022cc23ea$exports.fontWeight = Object.freeze({
    light: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject2 || ($bb6a8a3022cc23ea$var$_templateObject2 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 300;\n  "
    ]))),
    regular: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject3 || ($bb6a8a3022cc23ea$var$_templateObject3 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 400;\n  "
    ]))),
    medium: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject4 || ($bb6a8a3022cc23ea$var$_templateObject4 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 600;\n  "
    ]))),
    bold: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject5 || ($bb6a8a3022cc23ea$var$_templateObject5 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 700;\n  "
    ])))
});
var $bb6a8a3022cc23ea$var$boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadowFocus = (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject6 || ($bb6a8a3022cc23ea$var$_templateObject6 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
    "\n  &:focus {\n    box-shadow: 0px 0px 10px ",
    ";\n  }\n"
])), $bb6a8a3022cc23ea$var$color.d100);
var $bb6a8a3022cc23ea$var$gradient = $bb6a8a3022cc23ea$exports.gradient = Object.freeze({
    lagoon: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject7 || ($bb6a8a3022cc23ea$var$_templateObject7 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      87.41deg,\n      ",
        " 4.03%,\n      ",
        " 95.69%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.p500, $bb6a8a3022cc23ea$var$color.p600),
    wave: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject8 || ($bb6a8a3022cc23ea$var$_templateObject8 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(236.19deg, #133599 7.5%, #05164a 86.12%);\n  "
    ]))),
    nector: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject9 || ($bb6a8a3022cc23ea$var$_templateObject9 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      84.4deg,\n      #e00051 6.75%,\n      ",
        " 97.26%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.a500)
});
var $bb6a8a3022cc23ea$var$boxShadow = $bb6a8a3022cc23ea$exports.boxShadow = Object.freeze({
    level1: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject10 || ($bb6a8a3022cc23ea$var$_templateObject10 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level2: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject11 || ($bb6a8a3022cc23ea$var$_templateObject11 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level3: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject12 || ($bb6a8a3022cc23ea$var$_templateObject12 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level4: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject13 || ($bb6a8a3022cc23ea$var$_templateObject13 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 14px 28px rgba(0, 0, 0, 0.1);\n  "
    ]))),
    level5: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject14 || ($bb6a8a3022cc23ea$var$_templateObject14 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 19px 38px rgba(0, 0, 0, 0.15);\n  "
    ]))),
    focus: (0, $9wzIk$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject15 || ($bb6a8a3022cc23ea$var$_templateObject15 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 0px 10px ",
        ";\n  "
    ])), $bb6a8a3022cc23ea$var$color.d100)
});
var $bb6a8a3022cc23ea$var$border = $bb6a8a3022cc23ea$exports.border = Object.freeze({
    level1: "0.3px solid rgba(130, 130, 130, 0.5)"
});
var $bb6a8a3022cc23ea$var$layer = $bb6a8a3022cc23ea$exports.layer = Object.freeze({
    hidden: -1,
    select: 5,
    newQuoteButton: 45,
    navbar: 50,
    tooltip: 60,
    mobileSocialFooter: 70,
    popup: 90,
    modal: 100,
    slideOut: 1101,
    welcomeModal: 1301
});
var $bb6a8a3022cc23ea$var$viewports = $bb6a8a3022cc23ea$exports.viewports = {
    mobile: {
        width: 360,
        breakpoint: "sm"
    },
    tablet: {
        width: 768,
        breakpoint: "md"
    },
    desktop: {
        width: 1200,
        breakpoint: "lg"
    }
};
// https://material-ui.com/customization/default-theme/?expend-path=$.breakpoints.values
var $bb6a8a3022cc23ea$var$breakpoint = $bb6a8a3022cc23ea$exports.breakpoint = Object.freeze({
    // this prop is needed because webapp/imports/styledComponents/Grid/Column.js uses xs viewport
    xs: 0,
    sm: 0,
    md: $bb6a8a3022cc23ea$var$viewports.tablet.width,
    lg: $bb6a8a3022cc23ea$var$viewports.desktop.width
});
// https://getbootstrap.com/docs/4.3/layout/overview/
var $bb6a8a3022cc23ea$var$query = $bb6a8a3022cc23ea$exports.query = {
    min: {
        solve: function solve(width) {
            return "(min-width: ".concat(width, "px)");
        },
        tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px)")
    },
    max: {
        solve: function solve(width) {
            return "(max-width: ".concat(width - 0.02, "px)");
        },
        tablet: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)")
    },
    mobile: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px)"),
    tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px) and (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)"),
    desktop: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg, "px)"),
    dpr2x: "(min-resolution: 2dppx), (min-resolution: 192dpi)",
    mobileDpr2x: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 2dppx), (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 192dpi)")
};
Object.keys($bb6a8a3022cc23ea$var$breakpoint).forEach(function(key) {
    $bb6a8a3022cc23ea$var$query.min[key] = $bb6a8a3022cc23ea$var$query.min.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
    $bb6a8a3022cc23ea$var$query.max[key] = $bb6a8a3022cc23ea$var$query.max.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
});
Object.freeze($bb6a8a3022cc23ea$var$query);
Object.freeze($bb6a8a3022cc23ea$var$query.min);
Object.freeze($bb6a8a3022cc23ea$var$query.max);
var $bb6a8a3022cc23ea$var$Theme = $bb6a8a3022cc23ea$exports.Theme = Object.freeze({
    color: $bb6a8a3022cc23ea$var$color,
    typo: $bb6a8a3022cc23ea$var$typo,
    border: $bb6a8a3022cc23ea$var$border,
    boxShadow: $bb6a8a3022cc23ea$var$boxShadow,
    boxShadowFocus: $bb6a8a3022cc23ea$var$boxShadowFocus,
    gradient: $bb6a8a3022cc23ea$var$gradient,
    layer: $bb6a8a3022cc23ea$var$layer,
    fontWeight: $bb6a8a3022cc23ea$var$fontWeight,
    query: $bb6a8a3022cc23ea$var$query
});



var $b287f3a707d8a4a3$var$_useMediaQuery = $b287f3a707d8a4a3$var$_interopRequireDefault($9wzIk$muimaterialuseMediaQuery);
function $b287f3a707d8a4a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $b287f3a707d8a4a3$var$useWidth = $b287f3a707d8a4a3$exports.useWidth = function useWidth() {
    var isDesktop = (0, $b287f3a707d8a4a3$var$_useMediaQuery["default"])($bb6a8a3022cc23ea$exports.Theme.query.desktop);
    var isTablet = (0, $b287f3a707d8a4a3$var$_useMediaQuery["default"])($bb6a8a3022cc23ea$exports.Theme.query.tablet);
    var isMobile = (0, $b287f3a707d8a4a3$var$_useMediaQuery["default"])($bb6a8a3022cc23ea$exports.Theme.query.mobile);
    return {
        isDesktop: isDesktop,
        isTablet: isTablet,
        isMobile: isMobile
    };
};






//# sourceMappingURL=index.js.map
